import { isNativeFunction } from '@jlalmes/utils'

const listeners: Array<(element: HTMLElement) => void> = []

function hijackCreateElement(callback: (element: HTMLElement) => void) {
    listeners.push(callback)
    const originalCreateElement = document.createElement

    if (!isNativeFunction(originalCreateElement)) {
        return
    }

    document.createElement = function (
        this: Document,
        tagName: keyof HTMLElementTagNameMap,
        options?: ElementCreationOptions
    ) {
        const ret = originalCreateElement.call(this, tagName, options)
        listeners.forEach(listener => listener(ret))
        return ret
    } as typeof originalCreateElement
}

export function hijackCreateCanvasElement(callback: (canvas: HTMLCanvasElement) => void) {
    hijackCreateElement(element => {
        if (element.tagName === 'CANVAS') {
            callback(element as HTMLCanvasElement)
        }
    })
}

export function removeHijacks() {
    listeners.length = 0
}
